import { LinkGen, LOREN_ROUTES } from "../../../../../../../constants/loren-routes.constants";
import { LorenSidenavTourSteps } from "../../../../../../../constants/loren-tour-steps.constants";
import { LOREN_USER_ROLES } from "../../../../../../../services/loren-authentication-service/constants/loren-user-roles.constants";
import { LorenMenuItemType } from "../../../enums/loren-menu-item-type.enum";
import { LorenFeature } from "../../../../../../../enums/loren-feature.enum";
import { LorenMenuItem } from "../../../interfaces/loren-menu-item.interface";

import { environment } from "../../../../../../../../../environments/environment";

const { tenant } = environment;

const getAnchorId = (id: string) =>
  LorenSidenavTourSteps.find((x) => x.anchorId === id).anchorId;

const dashboardMenuItem = {
  title: "sidenav.dashboard",
  icon: "space_dashboard",
  path: LOREN_ROUTES.DASHBOARD,
  type: LorenMenuItemType.LINK,
  tourAnchorId: getAnchorId("dashboard"),
  featureToggle: LorenFeature.GENERIC_DASHBOARD,
};

const assetsMenuItem = {
  title: "sidenav.assets",
  icon: "account_tree",
  path: LOREN_ROUTES.ASSETS_LIST,
  type: LorenMenuItemType.LINK,
  tourAnchorId: getAnchorId("assets-list"),
  featureToggle: LorenFeature.GENERIC_DASHBOARD,
};

const getLocationsMenuItem = (icon = "hub", title = "sidenav.locations") => {
  const extraProps = icon ? {} : { iconType: "svg", look: "mb-3" };
  return {
    title,
    icon,
    path: LOREN_ROUTES.MAP,
    type: LorenMenuItemType.LINK,
    tourAnchorId: getAnchorId("locations"),
    ...extraProps,
  };
};

const tracesMenuItem = {
  title: "sidenav.traces",
  icon: "compass_calibration",
  path: LOREN_ROUTES.TRACES,
  tourAnchorId: getAnchorId("traces"),
  type: LorenMenuItemType.LINK,
  featureToggle: LorenFeature.GENERIC_TRACES,
};

const getReportsMenuItem = (icon = "library_books") => {
  return {
    icon,
    title: "sidenav.assets_report",
    path: LOREN_ROUTES.REPORTS,
    type: LorenMenuItemType.LINK,
    tourAnchorId: getAnchorId("reports"),
  };
};

const menuItemsPerTenant = {
  default: [
    dashboardMenuItem,
    getLocationsMenuItem(),
    tracesMenuItem,
    assetsMenuItem,
    getReportsMenuItem(),
  ],
  vivacom: [
    dashboardMenuItem,
    getLocationsMenuItem(),
    tracesMenuItem,
    assetsMenuItem,
    getReportsMenuItem("insert_chart"),
  ],
  ipko: [
    dashboardMenuItem,
    getLocationsMenuItem("map"),
    assetsMenuItem,
    getReportsMenuItem("insert_chart_outlined"),
  ],
};

const appMenuItems: LorenMenuItem[] = menuItemsPerTenant[tenant] ?? menuItemsPerTenant.default;

const adminAppMenuItems: LorenMenuItem[] = [
  {
    title: "sidenav.companies",
    icon: "account_balance",
    path: `${LOREN_ROUTES.ADMIN}/${LOREN_ROUTES.COMPANIES}`,
    type: LorenMenuItemType.LINK,
  },
  {
    title: "sidenav.accounts",
    icon: "account_circle",
    path: `${LOREN_ROUTES.ADMIN}/${LOREN_ROUTES.ACCOUNTS}`,
    type: LorenMenuItemType.LINK,
  },
  {
    title: "sidenav.devices",
    icon: "sensor",
    iconType: "svg",
    path: `${LOREN_ROUTES.ADMIN}/${LOREN_ROUTES.DEVICES}`,
    type: LorenMenuItemType.LINK,
  },
  {
    title: "sidenav.assets_report",
    icon: "insert_chart",
    path: `${LOREN_ROUTES.ADMIN}/${LOREN_ROUTES.REPORTS}`,
    type: LorenMenuItemType.LINK,
    role: [LOREN_USER_ROLES.ADMIN, LOREN_USER_ROLES.CHANNEL_ADMIN],
  },
  {
    title: "sidenav.vision_pipelines",
    icon: "visibility",
    path: LinkGen.VisionPipelines(),
    type: LorenMenuItemType.LINK,
    role: [LOREN_USER_ROLES.ADMIN, LOREN_USER_ROLES.CHANNEL_ADMIN],
  },
];

export const LOREN_MENU_ITEMS = {
  APP: appMenuItems,
  ADMIN: adminAppMenuItems,
};
